export default __webpack_public_path__ + "static/media/featured_area_oakville.869f82c2.webp";